module.exports = __webpack_public_path__ + "static/media/todays-appointments-blue.9554da3e.svg";